// firebaseClient.js
// Konum: src/firebaseClient.js
//
// ÖNEMLİ: Buradaki değerleri kendi projenden (qrmenu-client/src/firebaseClient.js
// dosyasından) KOPYALA. Aynı Firebase projesini kullanıyoruz — sadece Auth ve
// Firestore altyapısını paylaşıyoruz, veri koleksiyonlarımız (callwaiter_businesses,
// restaurants/*) 3AMenu'nün koleksiyonlarından tamamen ayrı.

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAik3O9_2FTdXdbWk39lTbOfp7Ssc_HXQo",
  authDomain: "qrmenu-3d46a.firebaseapp.com",
  projectId: "qrmenu-3d46a",
  storageBucket: "qrmenu-3d46a.firebasestorage.app",
  messagingSenderId: "128971457470",
  appId: "1:128971457470:web:df3de2962e654948276fef"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
